import api from "./api";

export const UserAuthService = {
  // ---------- AUTH ----------
  login: async (email, password) => {
    const { data } = await api.post("/v1/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    return data.user;
  },

  register: async (payload) => {
    const { data } = await api.post("/v1/auth/register", payload);
    return data.user;
  },

  getProfile: async () => {
    const { data } = await api.get("/v1/auth/profile");
    return data.user;
  },

  logout: async () => {
    await api.post("/v1/auth/logout");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  // ---------- USERS (Admin CRUD) ----------
  getAll: async () => {
    const { data } = await api.get("/v1/users"); 
    return data;
  },

  getById: async (id) => {
    const { data } = await api.get(`/v1/users/${id}`);
    return data;
  },

  update: async (id, payload) => {
    const { data } = await api.put(`/v1/users/${id}`, payload);
    return data;
  },

  delete: async (id) => {
    const { data } = await api.delete(`/v1/users/${id}`);
    return data;
  },
};
